import * as React from 'react';
import './index.scss';
import { StageDefault } from '@/context.ts';
import { fetch, GetHourRankRsp, RankItem, HourTopItem } from '@/fetch.ts';
import AnchorItem from '@hooks/web/public/anchorItem.tsx';
import Page from '@hooks/web/public/page.tsx';
import None from '@hooks/web/public/none.tsx';
import Swiper from 'swiper/js/swiper.min.js';
import defaultAvatar from '@images/web/default.png';
import 'swiper/swiper.scss';
const { useEffect, useState, useContext } = React;
interface Props {
  iStage: number,
}
let swi1 = null;
let swi2 = null;
const HourRank: React.FC<Props> = props => {
  const { iStage } = useContext(StageDefault);
  const [pageShow, PageShow] = useState<boolean>(true);
  // 小时榜
  const [vGameRank, VGameRank] = useState<RankItem[]>([]);
  const [vEntertainmentRank, VEntertainmentRank] = useState<RankItem[]>([]);
  const [showvGameRank, showVGameRank] = useState<RankItem[]>([]);
  const [showvEntertainmentRank, showVEntertainmentRank] = useState<RankItem[]>([]);
  // 小时冠军
  const [vGameHourRank, VGameHourRank] = useState<HourTopItem[]>([]);
  const [vEntertainmentHourRank, VEntertainmentHourRank] = useState<HourTopItem[]>([]);
  const gameChange = (index: number): void => {
    showVGameRank(vGameRank.slice((index) * 5, (index + 1) * 5 >= vGameRank.length ? vGameRank.length : (index + 1) * 5));
  }
  const entertainChange = (index: number): void => {
    showVEntertainmentRank(vEntertainmentRank.slice((index) * 5, (index + 1) * 5 >= vEntertainmentRank.length ? vEntertainmentRank.length : (index + 1) * 5));
  }
  useEffect(() => {
    PageShow(false);
    VGameRank([]);
    VEntertainmentRank([]);
    showVGameRank([]);
    showVEntertainmentRank([]);
    VGameHourRank([]);
    VEntertainmentHourRank([]);
    fetch.getHourRank(
      {
        iStage: props.iStage,
      },
    )
      .then((rsp: GetHourRankRsp) => {
        // console.log('小时榜', {
        //   iStage: props.iStage,
        // }, JSON.stringify(rsp));
        PageShow(true);
        VGameRank(rsp.vGameRank.value.slice(0, 25));
        VEntertainmentRank(rsp.vEntertainmentRank.value.slice(0, 25));

        showVGameRank(rsp.vGameRank.value.slice(0, 5));
        showVEntertainmentRank(rsp.vEntertainmentRank.value.slice(0, 5));

        VGameHourRank(rsp.vGameHourRank.value);
        VEntertainmentHourRank(rsp.vEntertainmentHourRank.value);
      })
  }, [props.iStage])

  useEffect(() => {
    if (vGameHourRank.length === 0) return;
    swi1 = null;
    swi1 = new Swiper('.swiper-container-1', {
      navigation: {
        nextEl: '#game-next',
        prevEl: '#game-prev',
      },
      initialSlide: vGameHourRank.length - 1,
      slidesPerView: 3,
      MutationObserver: true,
      observe: true,
    })
  }, [vGameHourRank])

  useEffect(() => {
    if (vEntertainmentHourRank.length === 0) return;
    swi2 = null;
    swi2 = new Swiper('.swiper-container-2', {
      navigation: {
        nextEl: '#entertainment-next',
        prevEl: '#entertainment-prev',
      },
      initialSlide: vEntertainmentHourRank.length - 1,
      slidesPerView: 3,
      MutationObserver: true,
      observe: true,
    })
  }, [vEntertainmentHourRank])

  return (
    <div
      className='web-hourRank'
    >
      {
        [[vGameHourRank, vGameRank, showvGameRank], [vEntertainmentHourRank, vEntertainmentRank, showvEntertainmentRank]].map((item: any, index: number) => (
          <div className='hourSide' key={index}>
            <div className='label'>
              <i className='icon'></i>
              <p>{index === 0 ? '游戏' : '娱乐'}小时榜</p>
            </div>
            <div className='hourChamption'>
              {item[0].length !== 0 && <div className="swiper-button-prev" id={index === 0 ? 'game-prev' : 'entertainment-prev'}></div>}
              <div className={`swiper-container swiper-container-${index + 1}`}>
                {
                  item[0].length !== 0 ?
                    <div className="swiper-wrapper">
                      {
                        item[0].map((item: HourTopItem) => (
                          <div key={Math.random()} className='swiper-slide'>
                            <div className='avatar'>
                              <img
                                title={item.sNickName}
                                src={item.sLogoUrl}
                                onError={(event: any): void => {
                                  event.target.onerror = null;
                                  event.target.src = defaultAvatar;
                                }}
                                onClick={(): void => {
                                  window.open('https://m.huya.com/' + item.tJump.iRoomId, '_blank');
                                }}
                              />
                              <p className='hourlabel'>{item.sDesc}</p>
                            </div>
                            <p
                              className='name'
                              onClick={(): void => {
                                window.open('https://m.huya.com/' + item.tJump.iRoomId, '_blank');
                              }}
                            >{item.sNickName}</p>
                          </div>
                        ))
                      }
                    </div>
                    :
                    <None text='暂无小时冠军数据' />
                }
              </div>
              {item[0].length !== 0 && <div className="swiper-button-next" id={index === 0 ? 'game-next' : 'entertainment-next'}></div>}
            </div>
            <ul className='rankList'>
              {
                item[2].length !== 0 ?
                  (
                    item[2].map((items: RankItem) => (
                      <AnchorItem key={items.lUid} width={450} {...items} />
                    ))
                  ) :
                  (
                    <None text='暂无小时榜数据' />
                  )
              }
            </ul>
            <div className='rankPage'>
              {
                pageShow &&
                <Page
                  pageLen={item[1].length % 5 === 0 ? item[1].length / 5 : Math.floor(item[1].length / 5) + 1}
                  setPageIndex={index === 0 ? gameChange : entertainChange}
                />
              }
            </div>
          </div>
        ))
      }
    </div>
  )
}

export default HourRank;